import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProperty } from '../../hooks/useProperty';
import { FORMS } from '../../schemas/stepMap';
import FormBuilder from '../../components/formBuilder';
import { Helmet } from 'react-helmet';
import PropertyPageHeader from '../../components/PropertyPageHeader';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase/clientApp';
import { useUser } from '../../hooks/useUser';

export default function PurchaseWorksheet() {
  const { propertyData } = useProperty();
  const { user } = useUser();
  const { propertyId } = useParams();
  const navigate = useNavigate();

  if (propertyData?.projectType === 'flip') {
    navigate('../flip-worksheet');
  }

  const purchaseWorksheetSchema = FORMS.purchaseWorksheet.schema;

  function logCompleted() {
    logEvent(analytics, 'purchase_analysis_worksheet_completed', {
      user_id: user?.uid,
      property_id: propertyData?.propertyId,
    });
  }

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - Purchase Worksheet</title>
      </Helmet>
      <section>
        <PropertyPageHeader
          title={purchaseWorksheetSchema.inputs.title}
          description={purchaseWorksheetSchema.inputs.description}
        />

        <FormBuilder
          formSchema={purchaseWorksheetSchema}
          formType={FORMS.purchaseWorksheet.formType}
          data={propertyData}
          docId={propertyId}
          onFormSubmitted={logCompleted}
        />
        <div></div>
      </section>
    </>
  );
}
